export const getNavigation = state => state.reactApp.location;
export const getError = state => state.reactApp.error;
